import { IconSearch, IconX } from '@tabler/icons-react';
import React from 'react';

const SearchComponent = ({ placeholder, onInputChange, onSearch, onClear, inputValue, inputId = 'table-search' }) => {
    return (
        <>
            <form onSubmit={(e) => { e.preventDefault(); onSearch() }} className='min-w-[200px] max-w-[400px] w-full flex items-center border-2 rounded-xl border-[var(--light-text)] px-2'>
                <input type='text' placeholder={placeholder || 'Search Here...'} id={inputId} onChange={(e) => onInputChange && onInputChange(e)} className='w-full p-2 text-sm bg-transparent focus:outline-none focus:border-none' defaultValue={inputValue} />
                {inputValue && <div className='cursor-pointer' onClick={() => onClear()} >
                    <IconX />
                </div>}
                <button type='submit'>
                    <IconSearch />
                </button>
            </form>
        </>
    )
}

export default SearchComponent